export const projects = [
  
  {
    id: 'scottsdale-hangar-one',
    title: 'Scottsdale Hangar One',
    location: 'Scottsdale, AZ',
    year: 2003,
    category: 'Corporate',
    client: 'Bennett Dorrance',
    featuredImage: '/images/projects/scottsdale-hangar-one-featured.jpg',
    images: [
      '/images/projects/scottsdale-hangar-one-01.jpg',
      '/images/projects/scottsdale-hangar-one-02.jpg',
      '/images/projects/scottsdale-hangar-one-03.jpg',
      '/images/projects/scottsdale-hangar-one-04.jpg',
    ],
    shortDescription: 'Privately owned five building hangar complex and flight club with luxurious amenities',
    description: `Scottsdale Hangar One is a privately owned, five building hangar complex and flight club located at the Scottsdale Airpark. 
    The approximately 140,000 square foot facility can accommodate up to fifteen aircraft in its two 30,000 square foot hangars. 
    A 108 ft long aluminum "paper" airplane adorns the roof. Interior spaces are luxuriously furnished with custom fixtures, upholstered ceilings, 
    exotic stone and terrazzo floorings, mahogany, ebony and other rare woods; silk and wool carpeting; Onyx wall panels, and top-of-the-line 
    building automation and audio visual systems. An approximately 68,500 square foot multipurpose facility adjoins the hangars and includes 
    below-grade parking, premium office space and entertainment space.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Phase Services'],
    scope: '140,000 sq ft facility with two 30,000 sq ft hangars, 68,500 sq ft multipurpose facility with below-grade parking, premium office space and entertainment space',
    challenges: [
      'Luxurious interior spaces requiring precise climate control',
      'Integration with high-end finishes and custom fixtures',
      'Below-grade parking ventilation requirements',
      'Coordination with architect and engineer design team'
    ],
    features: [
      'Two 30,000 sq ft aircraft hangars accommodating up to 15 aircraft',
      '108 ft long aluminum paper airplane roof sculpture',
      'Top-of-the-line building automation systems',
      'Premium office and entertainment spaces with custom finishes',
      'Below-grade parking facility',
      'Private restaurant for members and guests',
      'Collector car storage area',
      'Exotic stone, terrazzo, mahogany, and ebony finishes'
    ],
    generalContractor: 'Sundt Construction',
    architect: 'Swaback Partners, LLC',
    engineer: 'Swaback Partners, LLC',
    additionalInfo: `Bennett Dorrance's $20 million private hangar club set a new standard for Scottsdale aviation facilities. 
    The facility features 9-inch-thick concrete floors, space for aircraft maintenance, administration, indoor parking, a members-only restaurant, 
    and collector car storage. The project was completed in June-July 2003 after construction began in March 2003.`
  },
  {
    id: 'asu-foundation',
    title: 'ASU Foundation',
    location: 'Phoenix, AZ',
    year: 2006,
    category: 'Higher Education',
    client: 'Arizona State University',
    featuredImage: '/images/projects/asu-foundation-featured.jpg',
    images: [
      '/images/projects/asu-foundation-01.jpg',
      '/images/projects/asu-foundation-02.jpg',
      '/images/projects/asu-foundation-03.jpg',
    ],
    shortDescription: 'HVAC and plumbing design phase services for ASU Foundation building',
    description: `Complete mechanical design phase services for the ASU Foundation building in Phoenix. 
    The project included comprehensive HVAC and plumbing system design for this important university facility. 
    Working in collaboration with Architekton and Gould Evans architects and Energy Systems Design engineers, 
    Bel-Aire Mechanical provided expert mechanical design services to ensure optimal building performance and comfort.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Phase Services'],
    scope: 'Complete HVAC and plumbing design phase services for university foundation building',
    challenges: [
      'Coordination with multiple design firms',
      'Meeting university standards and requirements',
      'Energy-efficient design for institutional facility',
      'Integration with campus infrastructure systems'
    ],
    features: [
      'Energy-efficient HVAC design',
      'Sustainable plumbing systems',
      'Comprehensive design coordination',
      'Cost-effective mechanical solutions'
    ],
    generalContractor: 'McCarthy',
    architect: 'Architekton and Gould Evans',
    engineer: 'Energy Systems Design'
  },
  {
    id: 'charles-schwab-phoenix-data-center',
    title: 'Charles Schwab Phoenix Data Center',
    location: 'Chandler, AZ',
    year: 2007,
    category: 'Data Center',
    client: 'Charles Schwab & Co., Inc.',
    featuredImage: '/images/projects/charles-schwab-data-center-featured.jpg',
    images: [
      '/images/projects/charles-schwab-data-center-01.jpg',
      '/images/projects/charles-schwab-data-center-02.jpg',
      '/images/projects/charles-schwab-data-center-03.jpg',
      '/images/projects/charles-schwab-data-center-04.jpg',
    ],
    shortDescription: 'Mission-critical data center mechanical systems for financial services leader',
    description: `Complete mechanical systems design and installation for Charles Schwab's Phoenix data center facility in Chandler, AZ. 
    This mission-critical facility required precision cooling systems, redundant mechanical infrastructure, and high-reliability HVAC systems 
    to support 24/7 financial services operations. Working with Sundt Corporation as general contractor and Klawiter and Associates as architect, 
    Bel-Aire Mechanical delivered a robust mechanical solution designed by Regatta Enterprises to meet the stringent requirements of a 
    world-class financial data center.`,
    services: ['HVAC Systems', 'Precision Cooling', 'Plumbing', 'BIM-VDC'],
    scope: 'Complete mechanical systems for financial services data center with redundant cooling and backup systems',
    challenges: [
      'Mission-critical uptime requirements for financial operations',
      'Redundant mechanical systems design and installation',
      'Precision temperature and humidity control for server equipment',
      'Integration with existing Charles Schwab infrastructure',
      'Stringent security and access control protocols'
    ],
    features: [
      'Redundant HVAC systems for 24/7 operations',
      'Precision cooling for data center equipment',
      'Advanced monitoring and control systems',
      'Emergency backup mechanical systems',
      'High-efficiency cooling design',
      'Scalable infrastructure for future expansion'
    ],
    generalContractor: 'Sundt Corporation',
    architect: 'Klawiter and Associates, Inc.',
    engineer: 'Regatta Enterprises'
  },
  {
    id: 'city-of-phoenix-crime-lab',
    title: 'City of Phoenix Crime Lab',
    location: 'Phoenix, AZ',
    year: 2007,
    category: 'Laboratories',
    client: 'City of Phoenix',
    featuredImage: '/images/projects/phoenix-crime-lab-featured.jpg',
    images: [
      '/images/projects/phoenix-crime-lab-01.jpg',
      '/images/projects/phoenix-crime-lab-02.jpg',
      '/images/projects/phoenix-crime-lab-03.jpg',
      '/images/projects/phoenix-crime-lab-04.jpg',
      '/images/projects/phoenix-crime-lab-05.jpg',
    ],
    shortDescription: 'Award-winning mechanical systems for state-of-the-art forensics facility',
    description: `The City of Phoenix Crime Laboratory is a 2007 Award recipient of the &quot;Best Mechanical Project&quot; in the Southwest Contractors Magazine. 
    This ultra-modern 104,000 sq. ft., three-level &quot;L&quot; shaped building features lab space in one wing while office space occupies the other. 
    The facility houses examination facilities including laboratories for photo analysis, latent prints, DNA testing, toxicology, controlled substances, 
    and forensics. A mechanical penthouse houses the building's ample mechanical requirements, including air handling units, exhaust fans, and boilers. 
    The lab exhaust system is very critical, with approximately 50 combined fume hoods and bio-safety cabinets requiring very specific control and exhaust 
    systems throughout the facility.`,
    services: ['HVAC Systems', 'Laboratory Exhaust', 'BIM-VDC', 'Design Assist', 'Preconstruction'],
    scope: '104,000 sq ft three-level forensics laboratory with specialized HVAC, exhaust systems, and mechanical penthouse',
    challenges: [
      'Critical lab exhaust systems with 50+ fume hoods and bio-safety cabinets',
      'Firearm testing lab with sound attenuation and high air flow requirements',
      'Toxic lead control and ventilation for firing range',
      'Precise environmental controls for DNA testing and forensics',
      'Integration of mechanical penthouse with building systems',
      'Coordination of complex exhaust and control systems'
    ],
    features: [
      'Mechanical penthouse with air handling units, exhaust fans, and boilers',
      'Separate cooling tower on southwest corner',
      '50+ fume hoods and bio-safety cabinets with specific control systems',
      'Specialized laboratories for DNA, toxicology, and forensics',
      'Firearm testing lab with firing range featuring sound attenuation',
      'High air flow systems for toxic lead control',
      'Photo analysis and latent print examination facilities',
      'Controlled substances testing laboratories'
    ],
    generalContractor: 'Gilbane Building Company',
    architect: 'Crime Lab Design',
    additionalInfo: `Award-winning project recognized as &quot;Best Mechanical Project&quot; by Southwest Contractors Magazine in 2007. 
    The firearm testing lab features a specialized firing range for cartridge ejection and recovery analysis, with advanced sound attenuation 
    and high air flow systems to manage toxic lead released from bullets. Bel-Aire Mechanical provided Design Assist and Pre-Construction 
    Services using BIM technology to coordinate the complex mechanical requirements of this critical forensics facility.`
  },
  {
    id: 'countrywide-data-center',
    title: 'Countrywide Data Center',
    location: 'Chandler, AZ',
    year: 2007,
    category: 'Data Center',
    client: 'Countrywide',
    featuredImage: '/images/projects/countrywide-data-center-featured.jpg',
    images: [
      '/images/projects/countrywide-data-center-01.jpg',
      '/images/projects/countrywide-data-center-02.jpg',
      '/images/projects/countrywide-data-center-03.jpg',
      '/images/projects/countrywide-data-center-04.jpg',
    ],
    shortDescription: 'Mission-critical data center mechanical systems for financial services operations',
    description: `Complete mechanical systems design and installation for Countrywide&apos;s mission-critical data center facility in Chandler, AZ. 
    This project required state-of-the-art cooling systems, redundant mechanical infrastructure, and precision environmental controls to support 
    critical financial services and mortgage operations. Working with Hunt Construction Group as general contractor, Corgan Associates as architect, 
    and EYP Mission Critical Facilities as engineer, Bel-Aire Mechanical delivered a comprehensive mechanical solution designed to meet the rigorous 
    demands of a tier-level data center supporting nationwide financial operations.`,
    services: ['HVAC Systems', 'Precision Cooling', 'Plumbing', 'BIM-VDC', 'Preconstruction'],
    scope: 'Complete mechanical systems for mission-critical data center with redundant cooling and environmental controls',
    challenges: [
      'Mission-critical uptime requirements for financial operations',
      'Redundant mechanical systems for continuous operations',
      'Precision temperature and humidity control',
      'High-density cooling for server equipment',
      'Integration with mission-critical facilities design',
      'Coordination with specialized data center engineer'
    ],
    features: [
      'Redundant HVAC systems for 24/7 operations',
      'Precision cooling systems for data center equipment',
      'Mission-critical facilities design standards',
      'Advanced environmental monitoring and controls',
      'Emergency backup mechanical systems',
      'Scalable infrastructure for future growth',
      'High-efficiency cooling design'
    ],
    generalContractor: 'Hunt Construction Group',
    architect: 'Corgan Associates, Inc.',
    engineer: 'EYP Mission Critical Facilities, Inc.'
  },
  {
    id: 'asu-nursing-health-innovation',
    title: 'ASU Nursing and Health Innovation',
    location: 'Phoenix, AZ',
    year: 2009,
    category: 'Higher Education',
    client: 'Arizona Board of Regents – Arizona State University',
    featuredImage: '/images/projects/asu-nursing-health-innovation-featured.jpg',
    images: [
      '/images/projects/asu-nursing-health-innovation-01.jpg',
      '/images/projects/asu-nursing-health-innovation-02.jpg',
      '/images/projects/asu-nursing-health-innovation-03.jpg',
      '/images/projects/asu-nursing-health-innovation-04.jpg',
    ],
    shortDescription: 'LEED Gold certified five-story nursing and health innovation building serving one of the largest nursing programs in the U.S.',
    description: `A five-story, copper building that acts as a gateway to the Downtown Arizona State University Campus and home to one of the largest 
    nursing programs in the United States. Bel-Aire Mechanical provided the mechanical and plumbing services on the shell &amp; core and tenant improvement 
    for this 84,000 square-foot facility including new classrooms for nursing students. Located at Third and Fillmore streets, the modern glass and copper 
    structure includes a 200-seat conference center, a 60-seat computer classroom laboratory, student facilities, and faculty office and research space. 
    The building includes several sustainable elements and LEED Gold Level Certification was achieved from the United States Green Building Council.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Assist', 'Shell & Core', 'Tenant Improvement'],
    scope: '84,000 sq ft five-story nursing and health innovation building with classrooms, conference center, laboratories, and research space',
    challenges: [
      'LEED Gold certification requirements',
      'Integration of sustainable mechanical systems',
      'Climate control for diverse spaces (classrooms, labs, conference center)',
      'Shell & core and tenant improvement coordination',
      'Supporting one of the largest nursing programs in the U.S.',
      'Gateway building design coordination'
    ],
    features: [
      'LEED Gold Level Certification',
      '200-seat conference center with specialized HVAC',
      '60-seat computer classroom laboratory',
      'Modern glass and copper architectural structure',
      'Faculty office and research space',
      'Student facilities with advanced climate control',
      'Sustainable mechanical and plumbing systems',
      'Energy-efficient design elements',
      'Gateway to Downtown ASU Campus'
    ],
    generalContractor: 'DPR Construction',
    additionalInfo: `This iconic five-story copper building serves as a gateway to Arizona State University&apos;s Downtown Phoenix Campus and houses 
    one of the largest nursing programs in the United States. The 84,000 square-foot facility achieved LEED Gold certification through integration of 
    sustainable mechanical and plumbing systems. Bel-Aire Mechanical provided comprehensive Design Assist services for both shell &amp; core and tenant 
    improvement phases, ensuring seamless coordination of mechanical systems throughout the modern glass and copper structure.`
  },
  {
    id: 'apollo-riverpoint-center',
    title: 'Apollo Riverpoint Center',
    location: 'Phoenix, AZ',
    year: 2008,
    category: 'Corporate',
    client: 'Apollo Development Group',
    featuredImage: '/images/projects/apollo-riverpoint-center-featured.jpg',
    images: [
      '/images/projects/apollo-riverpoint-center-01.jpg',
      '/images/projects/apollo-riverpoint-center-02.jpg',
      '/images/projects/apollo-riverpoint-center-03.jpg',
      '/images/projects/apollo-riverpoint-center-04.jpg',
      '/images/projects/apollo-riverpoint-center-05.jpg',
    ],
    shortDescription: 'Award-winning 600,000 sq ft corporate headquarters campus for Apollo Group and University of Phoenix',
    description: `The Apollo Riverpoint Center serves as the headquarters for the Apollo Group and University of Phoenix, as well as providing significant 
    operational space for their online learning programs. This 38-acre campus includes one 10-story building with a full service kitchen facility, two 
    6-story buildings and two parking garages with 4,500 parking spaces. The offices cover 600,000 square feet. The facility provided the educational 
    institution with a hub to centralize its Online Learning programs and consolidate its headquarters in new and beautiful surroundings. The mechanical 
    system is composed of three packaged chiller plants with a standard VAV System on the ground floors. Typical floors have two air handlers with an 
    Under Floor Air Distribution System (UFAD). Rooftop energy recovery units that capture energy from the building exhaust and transfer it to the intake 
    air enhance energy efficiency.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Assist', 'Preconstruction', 'Manufacturing', 'BIM-VDC'],
    scope: '600,000 sq ft corporate campus with one 10-story building, two 6-story buildings, full service kitchen, and two parking garages with 4,500 spaces',
    challenges: [
      'Large-scale 38-acre campus coordination',
      'Multiple building integration (10-story and two 6-story buildings)',
      'Full service kitchen facility mechanical requirements',
      'Coordinating three packaged chiller plants',
      'Under Floor Air Distribution System (UFAD) implementation',
      'Fast-track construction schedule'
    ],
    features: [
      'Three packaged chiller plants',
      'Standard VAV System on ground floors',
      'Under Floor Air Distribution System (UFAD) on typical floors',
      'Rooftop energy recovery units for enhanced efficiency',
      'Energy capture and transfer from building exhaust',
      'Full service kitchen facility',
      '4,500 parking spaces across two garages',
      'Prefabricated plumbing components',
      'Offsite manufactured mechanical piping systems'
    ],
    generalContractor: 'Sundt Construction',
    architect: 'Carpenter Sellers Associates, SmithGroup JJR',
    additionalInfo: `Multi-award-winning project recognized with Award of Merit-Buildings, Environmental Excellence Award from Valley Forward Association, 
    Best High-Rise Office Building at 2008 Design Awards by Precast Concrete Institute, Best of 2008 Awards – Office by Southwest Contractor magazine, 
    and Best of the Best – Finalist – Office by Engineering News Record. Innovative prefabrication and offsite manufacturing saved 1,000 hours and 45 
    schedule days for plumbing components, while mechanical piping system prefabrication saved 66 schedule days and 2,600 man hours, significantly 
    expediting the installation schedule.`
  },
  {
    id: 'asu-polytechnic',
    title: 'ASU Polytechnic',
    location: 'Mesa, AZ',
    year: 2008,
    category: 'Higher Education',
    client: 'Arizona Board of Regents – Arizona State University',
    featuredImage: '/images/projects/asu-polytechnic-featured.jpg',
    images: [
      '/images/projects/asu-polytechnic-01.jpg',
      '/images/projects/asu-polytechnic-02.jpg',
      '/images/projects/asu-polytechnic-03.jpg',
      '/images/projects/asu-polytechnic-04.jpg',
      '/images/projects/asu-polytechnic-05.jpg',
    ],
    shortDescription: 'LEED Silver certified 245,000 sq ft fast-track academic campus with advanced BIM coordination',
    description: `Bel-Aire Mechanical completed with DPR Construction and the Arizona Board of Regents, a 245,000 sq. ft. facility achieving Silver 
    Leadership in Energy and Environmental Design (LEED) for New Construction. This project houses academic laboratories, university classrooms, faculty 
    offices, a lecture hall and a fine arts building that includes a &quot;black box theater&quot;, painting and drawing studios and gallery space. 
    The buildings which were meant to create dynamic pedestrian environments are designed around three-story atriums. Each atrium has three large fans 
    for increased air circulation and decreased energy use. Other sustainable features include exterior glazing to provide natural light, stabilized 
    decomposed granite to reduce the &quot;heat island&quot; effect, and a large retaining wall made of recycled concrete. In addition, 89% of the 
    waste for the site was either reused or hauled away for recycling.`,
    services: ['HVAC Systems', 'Plumbing', 'Medical Gas', 'Design Assist', 'BIM-VDC'],
    scope: '245,000 sq ft academic campus with 3 academic buildings (11 buildings structurally), laboratories, classrooms, lecture hall, and fine arts facilities',
    challenges: [
      'Fast-track 18-month schedule for 3 academic buildings (11 structural buildings)',
      'Tight coordination between multiple trades and construction crews',
      'Complex BIM and 3-D coordination process',
      'LEED Silver certification requirements',
      'Integration of HVAC, electrical, fire sprinklers, and ceilings',
      'Coordination across multiple buildings on campus',
      'Three-story atrium designs with specialized air circulation'
    ],
    features: [
      'LEED Silver certification for New Construction',
      'Three-story atriums with three large circulation fans per atrium',
      'Black box theater in fine arts building',
      'Painting and drawing studios with gallery space',
      'Academic laboratories and university classrooms',
      'Exterior glazing for natural light',
      'Stabilized decomposed granite to reduce heat island effect',
      'Recycled concrete retaining wall',
      '89% waste reused or recycled',
      'Advanced BIM/3-D coordination',
      'Energy-efficient air circulation systems'
    ],
    generalContractor: 'DPR Construction',
    architect: 'RSP Architects',
    engineer: 'Energy Systems Design',
    additionalInfo: `Fast-track project completed in 18 months, building 3 academic buildings which structurally amounted to 11 buildings total. 
    Bel-Aire Mechanical worked closely with DPR in the BIM and 3-D coordination process, coordinating HVAC, electrical, fire sprinklers, and ceilings 
    prior to construction. This 3-D modeling saved significant potential &quot;rework&quot; and saved the owner money. Bel-Aire&apos;s BIM/CAD department 
    coordinated not only the self-performed services (HVAC, Plumbing, Medical Gas) but also structural, electrical, and structured data cabling systems 
    required within the multiple buildings on the Polytechnic Campus. The project achieved LEED Silver certification with sustainable features including 
    atrium fans for energy efficiency, natural lighting, heat island reduction, and 89% waste diversion.`
  },
  {
    id: 'dpr-boutique',
    title: 'DPR Boutique',
    location: 'Phoenix, AZ',
    year: 2011,
    category: 'Corporate',
    client: 'DPR Construction',
    featuredImage: '/images/projects/dpr-boutique-featured.jpg',
    images: [
      '/images/projects/dpr-boutique-01.jpg',
      '/images/projects/dpr-boutique-02.jpg',
      '/images/projects/dpr-boutique-03.jpg',
      '/images/projects/dpr-boutique-04.jpg',
      '/images/projects/dpr-boutique-05.jpg',
      '/images/projects/dpr-boutique-06.jpg',
    ],
    shortDescription: 'Award-winning LEED Platinum net-zero energy office showcasing innovative passive cooling and urban revitalization',
    description: `A living laboratory for the community, DPR&apos;s new office is a unique example of urban revitalization and sustainability. 
    Conceptualized as a &quot;net-zero energy workplace of the future&quot;, DPR created an open-office environment housing 58 workstations and floater 
    spaces, nine conference/training/innovation/mediated technology rooms, support spaces, fully-equipped gym/locker facilities, and a zen room for a 
    quiet retreat. The office has incorporated passive/active cooling solutions including 87 operable windows, four shower towers, an 87-foot long, 
    zinc-clad solar chimney, and a 79 kW-dc rated photovoltaic solar panel covered parking lot to control the indoor environment naturally and produce 
    energy onsite. A Lucid Building Dashboard® system is utilized to allow DPR to monitor and share building water and gas usage, lighting and power 
    consumption, and photovoltaic energy production in real time.`,
    services: ['HVAC Systems', 'Mechanical', 'Design Build', 'Preconstruction'],
    scope: 'Net-zero energy office renovation with 58 workstations, conference rooms, gym facilities, and innovative passive cooling systems',
    challenges: [
      'Achieving net-zero energy performance',
      'Urban revitalization of existing building',
      'Integrating passive and active cooling solutions',
      'LEED Platinum certification requirements',
      'Complex solar chimney design and installation',
      'Real-time energy monitoring and dashboard integration',
      'Balancing natural ventilation with climate control'
    ],
    features: [
      'LEED Platinum Certification',
      'Net-zero energy design',
      '87 automated operable windows',
      'Four shower towers with misters for passive cooling',
      '87-foot long zinc-clad solar chimney (largest in Arizona)',
      '79 kW-dc photovoltaic solar panel covered parking lot',
      '12 Big Ass Fans® for high-volume/low-speed air circulation',
      'Lucid Building Dashboard® for real-time monitoring',
      'Automated building management system',
      'Fully-equipped gym/locker facilities',
      'Zen room for quiet retreat',
      'Urban revitalization showcase'
    ],
    generalContractor: 'DPR Construction',
    architect: 'SmithGroup JJR',
    additionalInfo: `Multi-award-winning project: RED Awards – Most Sustainable Project in Arizona (2012), Building Design + Construction Reconstruction 
    Awards – Bronze Winner (2012), and Best of&apos; – Best in Project in the Southwest (2012). The building&apos;s unique passive cooling system provides 
    a natural alternative for regulating the space. Air is cooled via shower heads and misters as it enters the shower towers, then ducted into the space 
    through dampers controlled by the automated building management system. The solar chimney, the largest of its kind in Arizona, draws air through the 
    shower towers and operable windows with a convection current. Fresh air enters through 87 automated operable windows that open and close based on 
    temperature demands. Featured in multiple industry publications and DPR&apos;s video series &quot;Low Tech Meets High Tech – DPR&apos;s Net-Zero Energy 
    Phoenix Office&quot;.`,
    links: [
      {
        title: 'YouTube Video - Low Tech Meets High Tech',
        url: 'https://www.youtube.com/watch?v=8L1jCbVy8Rs'
      },
      {
        title: 'DPR Green Construction Page',
        url: 'http://www.dpr.com/construction/expertise/green-construction'
      },
      {
        title: 'AZRE Magazine Article',
        url: 'http://azbigmedia.com/azre-magazine/architecture-news/old-boutique-gets-new-life-dpr-constructions-headquarters'
      },
      {
        title: 'ENR Southwest Article',
        url: 'http://southwest.construction.com/opinions/blogs/?plckController=Blog&plckBlogPage=BlogViewPost&newspaperUserId=0a7f68ed-c0b4-4609-8b8e-00853e33207e&plckPostId=Blog%3a0a7f68ed-c0b4-4609-8b8e-00853e33207ePost%3a565d7a54-c85b-4fa6-b66b-513200c2bf31&plckScri'
      },
      {
        title: 'Phoenix Business Journal Article',
        url: 'http://www.bizjournals.com/phoenix/blog/business/2011/10/dpr-construction-turns-former-sex-shop.html'
      }
    ]
  },
  {
    id: 'digital-realty-trust-data-center',
    title: 'Digital Realty Trust Data Center',
    location: 'Chandler, AZ',
    year: 2011,
    category: 'Data Center',
    client: 'Digital Realty Trust',
    featuredImage: '/images/projects/digital-realty-trust-featured.jpg',
    images: [
      '/images/projects/digital-realty-trust-01.jpg',
      '/images/projects/digital-realty-trust-02.jpg',
      '/images/projects/digital-realty-trust-03.jpg',
      '/images/projects/digital-realty-trust-04.jpg',
    ],
    shortDescription: 'Mission-critical data center with advanced BIM coordination and precision mechanical systems',
    description: `Complete mechanical systems design and installation for Digital Realty Trust&apos;s mission-critical data center facility in Chandler, AZ. 
    This project required state-of-the-art HVAC systems, precision cooling, and comprehensive plumbing infrastructure to support high-density server 
    operations. Working with DPR Construction as general contractor, DGA as architect, and Energy System Design as engineer, Bel-Aire Mechanical 
    leveraged advanced BIM technology to coordinate all mechanical systems, ensuring seamless integration and optimal performance for this critical 
    digital infrastructure facility.`,
    services: ['HVAC Systems', 'Plumbing', 'BIM-VDC', 'Precision Cooling'],
    scope: 'Complete mechanical and plumbing systems for mission-critical data center with advanced BIM coordination',
    challenges: [
      'Mission-critical uptime requirements for data operations',
      'Precision cooling for high-density server equipment',
      'Advanced BIM coordination for complex mechanical systems',
      'Integration with energy-efficient design standards',
      'Coordination between multiple engineering disciplines',
      'Tight construction schedule requirements'
    ],
    features: [
      'Advanced BIM/VDC coordination',
      'Mission-critical HVAC systems',
      'Precision cooling for data center equipment',
      'Redundant mechanical infrastructure',
      'Energy-efficient mechanical design',
      'High-reliability plumbing systems',
      'Advanced monitoring and control systems',
      'Scalable infrastructure for future expansion'
    ],
    generalContractor: 'DPR Construction',
    architect: 'DGA',
    engineer: 'Energy System Design'
  },
  {
    id: 'asu-mccord-hall',
    title: 'ASU McCord Hall',
    location: 'Tempe, AZ',
    year: 2013,
    category: 'Higher Education',
    client: 'Arizona Board of Regents – Arizona State University',
    featuredImage: '/images/projects/asu-mccord-hall-featured.jpg',
    images: [
      '/images/projects/asu-mccord-hall-01.jpg',
      '/images/projects/asu-mccord-hall-02.jpg',
      '/images/projects/asu-mccord-hall-03.jpg',
      '/images/projects/asu-mccord-hall-04.jpg',
      '/images/projects/asu-mccord-hall-05.jpg',
    ],
    shortDescription: 'Award-winning 129,000 sq ft LEED Silver sustainable academic building featuring innovative UFAD system',
    description: `This four-story sustainable structure is located on the ASU Campus in Tempe, AZ. Approximately 129,000 sq ft and LEED Silver 
    Certification. It features a classroom and studio for masters of real-estate development students, 10 auditorium-style classrooms, four 
    traditional-style classrooms and 40 team rooms where small groups of students can work on projects in a collaborative setting. Additionally, 
    the building offers computer labs, specialized industry spaces, executive education facilities, conference rooms and study areas. The building 
    features an under floor air distribution system or UFAD System which uses a plenum beneath the raised access floor to deliver conditioned air 
    up through floor diffusers directly to the occupied zone.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Assist', 'Preconstruction', 'BIM-VDC'],
    scope: '129,000 sq ft four-story academic building with UFAD system, 10 auditorium-style classrooms, 40 team rooms, and specialized facilities',
    challenges: [
      'LEED Silver certification requirements',
      'Implementation of Under Floor Air Distribution (UFAD) system',
      'Integration with campus district cooling system',
      'Coordination with existing underground tunnel utilities',
      'Four large rooftop air handling units (42,000 cfm each)',
      'Sustainable design and energy efficiency goals',
      'Complex coordination with multiple classroom types'
    ],
    features: [
      'LEED Silver Certification',
      'Under Floor Air Distribution (UFAD) system',
      'Four large rooftop air handling units (42,000 cfm each)',
      'Campus District Cooling System integration',
      'Underground chilled water piping network',
      'Raised access floor plenum system',
      'Natural air stratification for improved air quality',
      'Lower contaminant concentration in breathing zone',
      '10 auditorium-style classrooms',
      '4 traditional-style classrooms',
      '40 team collaboration rooms',
      'Computer labs and specialized industry spaces',
      'Executive education facilities',
      'Conference rooms and study areas'
    ],
    generalContractor: 'DPR Construction',
    architect: 'RSP Architects, Kohn Pedersen Fox Associates PC (KPF)',
    engineer: 'Energy Systems Design',
    additionalInfo: `Award-winning project recognized at the 2014 AZRE RED Awards (Real Estate and Development) as &quot;Best Public Project: McCord Hall&quot;. 
    The innovative UFAD system relies on natural stratification of air where warm air rises due to thermal buoyancy. Since conditioned air is distributed 
    from the floor up, occupants breathe air that contains a lower concentration of contaminants compared to conventional overhead air delivery systems. 
    Chilled water is provided by the Campus District Cooling System, where a network of chilled water piping is routed underground and ties into an 
    existing tunnel system that houses all central plant utilities. This sustainable design showcases Bel-Aire Mechanical&apos;s expertise in advanced 
    HVAC systems and integration with campus infrastructure.`
  },
  {
    id: 'cyrusone-chandler',
    title: 'CyrusOne Chandler Data Center',
    location: 'Chandler, AZ',
    year: 2014,
    category: 'Data Center',
    client: 'CyrusOne',
    featuredImage: '/images/projects/cyrusone-featured.jpg',
    images: [
      '/images/projects/cyrusone-01.jpg',
      '/images/projects/cyrusone-02.jpg',
      '/images/projects/cyrusone-03.jpg',
      '/images/projects/cyrusone-04.jpg',
      '/images/projects/cyrusone-05.jpg',
    ],
    shortDescription: 'Fast-track mission-critical data center built in 107 days with advanced cooling systems',
    description: `CyrusOne specializes in highly reliable enterprise-class, carrier-neutral data center properties. The company provides mission-critical 
    data center facilities that protect and ensure the continued operation of IT infrastructure for more than 655 customers. This remarkable project 
    showcases the successful construction of a sophisticated data center in just 107 days. The facility features a 36-inch raised floor design, closed 
    loop chilled water cooling design, Stulz 200-ton CRAH units with electronically commutated (EC) variable-speed fans, and Trane 500-ton highly 
    efficient chillers with fast restart and adaptive controlled microprocessors.`,
    services: ['HVAC Systems', 'Precision Cooling', 'Design Assist', 'BIM-VDC', 'Plumbing'],
    scope: 'Mission-critical data center with advanced cooling infrastructure built in fast-track 107-day schedule',
    challenges: [
      'Extremely fast-track 107-day construction schedule',
      'Mission-critical uptime requirements',
      'Complex coordination for rapid deployment',
      'Advanced BIM-VDC coordination for accelerated timeline',
      'Integration of sophisticated cooling systems',
      'Closed loop chilled water system design',
      'Precision installation of raised floor infrastructure'
    ],
    features: [
      '107-day fast-track construction',
      '36-inch raised floor design',
      'Closed loop chilled water cooling system',
      'Stulz 200-ton CRAH units',
      'Electronically commutated (EC) variable-speed fans',
      'Trane 500-ton highly efficient chillers',
      'Fast restart and adaptive controlled microprocessors',
      'Enterprise-class, carrier-neutral facility',
      'Mission-critical reliability standards',
      'Advanced BIM-VDC coordination',
      'Serves 655+ customers'
    ],
    generalContractor: 'DPR Construction',
    architect: 'Corgan Associates, Inc.',
    engineer: 'kW Mission Critical Engineering',
    additionalInfo: `Remarkable fast-track project that successfully built a sophisticated data center in just 107 days. Featured in multiple industry 
    publications and media coverage highlighting the innovative construction approach and advanced mechanical systems. The facility serves CyrusOne&apos;s 
    mission to provide highly reliable enterprise-class, carrier-neutral data center properties that protect and ensure the continued operation of IT 
    infrastructure for more than 655 customers. This project demonstrates Bel-Aire Mechanical&apos;s ability to deliver complex mission-critical 
    facilities on accelerated schedules while maintaining the highest standards of quality and reliability.`,
    links: [
      {
        title: 'Virtual Tour - CyrusOne Chandler/Phoenix Data Center',
        url: 'https://www.youtube.com/watch?v=NsfRN4vIygo'
      },
      {
        title: 'CyrusOne Media Coverage - Building in 107 Days',
        url: 'http://www.cyrusone.com/media-coverage/2014-media-coverage/cyrusone-builds-second-phoenix-site-in-107-days/'
      },
      {
        title: 'DPR Review - Building a Data Center in 107 Days',
        url: 'http://dpr-review.com/spring-2015/story/building-a-data-center-in-107-days'
      }
    ]
  },
  {
    id: 'banner-health-portfolio',
    title: 'Banner Health - Portfolio of Projects',
    location: 'Phoenix Metropolitan Area, AZ',
    year: 2024,
    category: 'Healthcare',
    client: 'Banner Health',
    featuredImage: '/images/projects/banner-health-portfolio-featured.jpg',
    images: [
      '/images/projects/banner-health-portfolio-01.jpg',
      '/images/projects/banner-health-portfolio-02.jpg',
      '/images/projects/banner-health-portfolio-03.jpg',
      '/images/projects/banner-health-portfolio-04.jpg',
      '/images/projects/banner-health-portfolio-05.jpg',
      '/images/projects/banner-health-portfolio-06.jpg',
    ],
    shortDescription: 'Long-term partnership delivering mechanical systems for multiple Banner Health facilities across the Phoenix metropolitan area',
    description: `Here at Bel-Aire Mechanical we have worked with Banner Health for many years and within this portfolio you will see highlights of the 
    work we have completed. Bel-Aire Mechanical has for many years, enjoyed a significant share of the high-tech laboratories that have been built in 
    the metropolitan Phoenix area. Some of our pridefully completed projects include MD Anderson, Dignity Health Care (St. Joseph&apos;s Hospital, 
    Barrows Neurological Center), Banner Mesa, Banner Boswell, Banner Del E. Webb Hospital, Scottsdale Health Care, John C Lincoln Health Care and 
    many others. The location of Bel-Aire Mechanical is an integral advantage in maintaining a significant presence to our trade affiliates, vendors, 
    and subcontractors.`,
    services: ['HVAC Systems', 'Plumbing', 'Medical Gas', 'Laboratory Systems', 'BIM-VDC', 'Service & Maintenance'],
    scope: 'Ongoing partnership providing mechanical, HVAC, plumbing, and medical gas systems across multiple Banner Health facilities',
    challenges: [
      'Working in active healthcare facilities',
      'Maintaining infection control standards',
      'Coordination with hospital operations and schedules',
      'Complex medical gas systems installation',
      'High-tech laboratory mechanical requirements',
      'Meeting stringent healthcare regulations',
      'Multiple concurrent projects across various facilities',
      'Maintaining consistent quality across all locations'
    ],
    features: [
      'Long-term partnership with Banner Health',
      'Multiple facility experience across Phoenix metro',
      'Banner Mesa medical systems',
      'Banner Boswell mechanical infrastructure',
      'Banner Del E. Webb Hospital systems',
      'High-tech laboratory expertise',
      'Medical gas distribution systems',
      'HVAC systems for healthcare environments',
      'Local Arizona-based workforce',
      'Established relationships with local suppliers and vendors',
      'Proven track record of on-time, on-budget delivery',
      'Support for Dignity Health Care facilities',
      'St. Joseph&apos;s Hospital projects',
      'Barrows Neurological Center systems',
      'MD Anderson collaboration'
    ],
    additionalInfo: `Bel-Aire Mechanical has established a long-term partnership with Banner Health, one of the largest healthcare systems in Arizona. 
    Our work spans multiple Banner facilities including Banner Mesa, Banner Boswell, and Banner Del E. Webb Hospital. We have successfully completed 
    a significant share of the high-tech laboratories built in the metropolitan Phoenix area. Our local presence provides an integral advantage in 
    maintaining strong relationships with trade affiliates, vendors, and subcontractors. We maintain a well-established record of successfully 
    completing laboratory and healthcare projects on time and within budget. All of our employees reside in the State of Arizona, and we understand 
    the importance of supporting and utilizing local resources. Many of our suppliers, vendors, and subcontractors have worked with us since our 
    first projects, demonstrating the strength and longevity of our professional relationships.`
  },
  {
    id: 'u-of-a-cancer-center',
    title: 'University of Arizona Cancer Center',
    location: 'Phoenix, AZ (Downtown)',
    year: 2015,
    category: 'Healthcare',
    client: 'University of Arizona',
    featuredImage: '/images/projects/u-of-a-cancer-center-featured.jpg',
    images: [
      '/images/projects/u-of-a-cancer-center-01.jpg',
      '/images/projects/u-of-a-cancer-center-02.jpg',
      '/images/projects/u-of-a-cancer-center-03.jpg',
      '/images/projects/u-of-a-cancer-center-04.jpg',
      '/images/projects/u-of-a-cancer-center-05.jpg',
      '/images/projects/u-of-a-cancer-center-06.jpg',
    ],
    shortDescription: 'LEED Gold state-of-the-art 220,000 sq ft cancer treatment facility on Phoenix Biomedical Campus',
    description: `Downtown Phoenix&apos;s newest jewel, the University of Arizona Cancer Center, opened in 2015. This five-story 220,000 square foot 
    building is located on the Phoenix Biomedical Campus and achieved LEED Gold Certification. This state-of-the-art facility offers comprehensive 
    cancer treatment services including infusion, radiation oncology, diagnostic imaging, endoscopic and interventional radiology, a women&apos;s center, 
    specialized cancer clinics, patient wellness and support services, prevention health clinic, clinical laboratory space and other support spaces. 
    Bel-Aire Mechanical set up a collaborative workspace for the Design Team to complete the mechanical, plumbing and medical gas systems as well as 
    BIM modeling and coordination.`,
    services: ['HVAC Systems', 'Plumbing', 'Medical Gas', 'Design Assist', 'BIM-VDC'],
    scope: '220,000 sq ft five-story comprehensive cancer treatment facility with advanced mechanical, plumbing, and medical gas systems',
    challenges: [
      'LEED Gold certification requirements',
      'Complex medical gas systems for cancer treatment',
      'Advanced BIM coordination for design team collaboration',
      'Precision environmental controls for medical spaces',
      'Integration of 398 active chilled beams',
      'Four large variable volume air handling units',
      'District cooling system integration',
      'Specialized ventilation for radiation oncology and imaging'
    ],
    features: [
      'LEED Gold Certification',
      'Four large variable volume air handling units',
      'Four heating hot water condensing boilers',
      '398 active chilled beams for comfort and efficiency',
      'Humidifiers and air terminal units with hot water reheat',
      'District cooling chilled water system',
      'Domestic water booster pumping station',
      'Two natural gas water heaters with 500-gallon storage',
      'Drinking fountains with remote chillers',
      'Duplex stacked medical air plant',
      'Duplex stacked medical vacuum plant',
      'Alarm panels and medical gas outlets',
      'Liquid automatic changeover panel with high-pressure reserve cylinders',
      'Comprehensive infusion services',
      'Radiation oncology facilities',
      'Diagnostic imaging and interventional radiology',
      'Women&apos;s center',
      'Specialized cancer clinics',
      'Patient wellness and support services',
      'Prevention health clinic',
      'Clinical laboratory space'
    ],
    generalContractor: 'Hensel Phelps',
    architect: 'Zimmer Gunsul Frasca Architects LLC',
    engineer: 'Affiliated Engineers Inc.',
    additionalInfo: `Bel-Aire Mechanical established a collaborative workspace for the Design Team to complete the mechanical, plumbing, and medical gas 
    systems as well as BIM modeling and coordination. Early collaboration on the project allowed the entire team to maximize the benefits of BIM technology. 
    The indoor environment is maintained by four large variable volume air handling units, four heating hot water condensing boilers, humidifiers, air 
    terminal units with hot water reheat, various exhaust systems, and 398 active chilled beams for maximum comfort, efficiency, and optimum performance. 
    Chilled water is provided by district cooling. The plumbing and medical gas systems include a domestic water booster pumping station, two natural gas 
    water heaters with 500-gallon storage capacity, pumps and lift station, drinking fountains with remote chillers, duplex stacked medical air plant, 
    duplex stacked medical vacuum plant, alarm panels, wall and boom outlets, and liquid automatic changeover panel with high-pressure reserve cylinders.`,
    links: [
      {
        title: 'BIM Flythrough - Hensel Phelps',
        url: 'https://www.youtube.com/watch?v=pHPE5nQ_Fx4'
      }
    ]
  },
  {
    id: 'marina-heights',
    title: 'Marina Heights',
    location: 'Tempe, AZ',
    year: 2015,
    category: 'Corporate',
    client: 'State Farm',
    featuredImage: '/images/projects/marina-heights-featured.jpg',
    images: [
      '/images/projects/marina-heights-01.jpg',
      '/images/projects/marina-heights-02.jpg',
      '/images/projects/marina-heights-03.jpg',
      '/images/projects/marina-heights-04.jpg',
      '/images/projects/marina-heights-05.jpg',
    ],
    shortDescription: 'Complex 4,200-space parking garage with advanced drainage and pumping systems discharging to Tempe Town Lake',
    description: `The 4,200-space parking garage consists of a B2 level, B1 level with regular, nuisance and siphonic type draining systems on the 
    plaza deck that diverts the water to large above ground storage tanks and to three under ramp storage tanks before being clarified and pumped 
    into Tempe Town Lake. Bel-Aire Mechanical performed the installation of two sizes of above ground storage tanks with sump pumps. The dual pumping 
    systems ranged from 7.5 hp to 20 hp pumps. Other pumping systems were small, single nuisance pumps located throughout the B2 level of the garage, 
    in the elevator shafts and exhaust shafts for a total of 74 pumps.`,
    services: ['Plumbing', 'BIM-VDC', 'Pumping Systems', 'Drainage Systems'],
    scope: '4,200-space parking garage with complex below-grade drainage, storage tanks, and 74-pump system discharging to Tempe Town Lake',
    challenges: [
      'Complex below-grade expansive parking structure',
      'Multiple drainage system types (regular, nuisance, siphonic)',
      'Installation of large above ground storage tanks',
      'Three under ramp storage tanks',
      'Water clarification system before lake discharge',
      '74 pumps throughout facility',
      'Extensive piping with varying sizes (15" to 2")',
      'Over 34,000 linear feet of piping',
      'Coordination with Tempe Town Lake discharge requirements'
    ],
    features: [
      '4,200-space parking garage',
      'B2 and B1 level construction',
      'Regular, nuisance, and siphonic drainage systems',
      'Large above ground storage tanks',
      'Three under ramp storage tanks',
      'Water clarification system',
      'Discharge to Tempe Town Lake',
      '74 pumps total (7.5 hp to 20 hp)',
      'Dual pumping systems',
      'Nuisance pumps in elevator and exhaust shafts',
      'Cast iron piping (15" to 2")',
      'Copper pipe (8" to 2.5")',
      'Grooved galvanized piping (12" to 2")',
      'Over 34,000 linear feet of total piping',
      'Plaza deck drainage system',
      'Advanced BIM coordination'
    ],
    generalContractor: 'Ryan Companies US, Inc.',
    architect: 'Davis',
    engineer: 'Kraemer Consulting, PLLC',
    additionalInfo: `This project demonstrates Bel-Aire Mechanical&apos;s ability to understand and successfully complete a complex below-grade expansive 
    parking structure. The extensive piping size ranges varied from 15&quot; to 2&quot; cast iron, 8&quot; to 2.5&quot; copper pipe, as well as grooved 
    galvanized ranging from 12&quot; to 2&quot;. The approximate total pipe on the entire project was over 34,000 linear feet. The sophisticated drainage 
    system includes regular, nuisance, and siphonic type draining systems on the plaza deck that divert water to large above ground storage tanks and 
    three under ramp storage tanks before being clarified and pumped into Tempe Town Lake. The project featured 74 pumps throughout the facility, 
    including dual pumping systems ranging from 7.5 hp to 20 hp, and small single nuisance pumps located throughout the B2 level, in elevator shafts, 
    and exhaust shafts.`,
    links: [
      {
        title: 'Project Video - Marina Heights',
        url: 'https://vimeo.com/71303533?fl=pl&fe=vl'
      }
    ]
  },
  {
    id: 'desert-diamond-west-valley',
    title: 'Desert Diamond West Valley Resort',
    location: 'Glendale, AZ',
    year: 2016,
    category: 'Casino-Resort',
    client: 'Tohono O&apos;odham Gaming Enterprise',
    featuredImage: '/images/projects/desert-diamond-featured.jpg',
    images: [
      '/images/projects/desert-diamond-01.jpg',
      '/images/projects/desert-diamond-02.jpg',
      '/images/projects/desert-diamond-03.jpg',
      '/images/projects/desert-diamond-04.jpg',
      '/images/projects/desert-diamond-05.jpg',
      '/images/projects/desert-diamond-06.jpg',
    ],
    shortDescription: 'Fast-track 130,000 sq ft casino resort with 2,000-ton central plant and state-of-the-art gaming facilities',
    description: `The first phase of the Desert Diamond Casino has arrived and is one of the valley&apos;s hottest venues! The low-rise building is situated 
    on 135 acres and boasts a 50,750 square foot interim casino that is outfitted with 1,089 slot machines, state-of-the-art electronics, booming sound 
    system and computerized LED lighting to set any mood. Total build out of this two-story structure is approximately 130,000 square feet. Construction 
    began in January 2015 and the casino held a Grand Opening Ceremony on December 20, 2015 with plans to remain open 24/7 indefinitely. At its core, 
    the spacious 2,000-ton central plant has been built out to allow for future expansion and growth to approximately 5,000 tons.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Assist', 'BIM-VDC', 'Design Build'],
    scope: '130,000 sq ft two-story casino resort with 2,000-ton central plant, gaming floor, food court, offices, and separate 6,000 sq ft modular facility',
    challenges: [
      'Aggressive 12-month construction schedule (Jan 2015 - Dec 2015)',
      '24/7 casino operations requirements',
      'Complex BIM coordination for fast-track delivery',
      '2,000-ton central plant with 5,000-ton expansion capability',
      'Specialized CRAC units for security and server rooms',
      'Just-In-Time delivery coordination',
      'Immense ventilation system for gaming floor',
      'Tight temperature and humidity controls for critical spaces'
    ],
    features: [
      '135-acre site development',
      '50,750 sq ft interim casino with 1,089 slot machines',
      '130,000 sq ft total two-story structure',
      '2,000-ton central plant (expandable to 5,000 tons)',
      'Massive cooling towers with 30&quot; headers',
      'Plate and frame heat exchanger for efficiency',
      'Variable frequency drives on all pumps and air handling units',
      'Eight computer room air conditioning (CRAC) units',
      'Twin cooling (chilled water primary, direct expansion backup)',
      'State-of-the-art electronics and LED lighting',
      'Immense ventilation system for gaming floor',
      'Food court and food storage facility',
      'Loading dock area',
      'Rewards Center',
      'Beverage bars and main bar',
      'Executive offices and vault area',
      'Security offices and holding cells',
      'Eye-In-The-Sky surveillance rooms',
      'Server rooms with redundant cooling',
      'Separate 6,000 sq ft modular office and employee dining facility',
      '24/7 operation capability'
    ],
    generalContractor: 'Hunt / Penta Construction',
    architect: 'Hnedak Bobo Group',
    engineer: 'JBA Consulting Engineers',
    additionalInfo: `With an aggressive construction schedule, Bel-Aire&apos;s Team collaborated with the Owner, designers, and other trade partners to 
    establish project milestones and sequences and provide design assistance to complete the HVAC and Plumbing systems. Bel-Aire&apos;s BIM modelers 
    worked tirelessly to minimize space conflicts, reduce installation durations, and allow for early manufacturing of duct and pipe to ensure 
    &quot;Just-In-Time&quot; deliveries. The massive cooling towers and 30&quot; headers are situated on the west side of the building. The plant offers 
    a plate and frame heat exchanger for maximum efficiency during cooler months. All pumps and air handling units have been equipped with variable 
    frequency drives to optimize performance while cutting operating costs. The &quot;Eye-In-The-Sky&quot;, security and server rooms are equipped with 
    eight computer room air conditioning units (CRAC&apos;s) that are twin cooled with chilled water as the primary source and direct expansion as the 
    secondary source, maintaining tight tolerances of temperature and humidity with maximum reliability and redundancy. Additionally, Bel-Aire provided 
    design build services for a separate 6,000 square foot modular office building and employee dining facility. Grand Opening: December 20, 2015.`
  },
  {
    id: 'phoenix-childrens-hospital-trauma-center',
    title: 'Phoenix Children\'s Hospital - Trauma Center',
    location: 'Phoenix, AZ',
    year: 2018,
    category: 'Healthcare',
    client: 'Phoenix Children\'s Hospital',
    featuredImage: '/images/projects/phoenix-childrens-trauma-featured.jpg',
    images: [
      '/images/projects/phoenix-childrens-trauma-01.jpg',
      '/images/projects/phoenix-childrens-trauma-02.jpg',
      '/images/projects/phoenix-childrens-trauma-03.jpg',
      '/images/projects/phoenix-childrens-trauma-04.jpg',
    ],
    shortDescription: 'Critical trauma center expansion with advanced HVAC, plumbing, and BIM coordination for pediatric emergency care',
    description: `Phoenix Children's Hospital Trauma Center expansion project represents a critical addition to Arizona's pediatric healthcare 
    infrastructure. This specialized facility required sophisticated mechanical systems designed to meet the unique demands of pediatric trauma care, 
    including precise environmental controls, infection control standards, and 24/7 operational reliability. Bel-Aire Mechanical provided comprehensive 
    HVAC and plumbing systems with advanced BIM coordination to ensure seamless integration with the hospital's existing infrastructure while 
    maintaining continuous operations throughout construction.`,
    services: ['HVAC Systems', 'Plumbing', 'BIM-VDC', 'Medical Gas'],
    scope: 'Trauma center expansion with specialized HVAC, plumbing, and medical gas systems for pediatric emergency care',
    challenges: [
      'Working in active hospital environment',
      'Maintaining infection control during construction',
      'Critical 24/7 operational requirements',
      'Pediatric-specific environmental controls',
      'Integration with existing hospital infrastructure',
      'Advanced BIM coordination for complex systems',
      'Specialized trauma room mechanical requirements',
      'Emergency department ventilation standards'
    ],
    features: [
      'Specialized trauma center HVAC systems',
      'Pediatric-specific environmental controls',
      'Medical gas distribution systems',
      'Emergency department plumbing infrastructure',
      'Advanced infection control ventilation',
      'Redundant mechanical systems for reliability',
      '24/7 operational capability',
      'BIM coordination for seamless integration',
      'Precision temperature and humidity control',
      'High-efficiency air filtration systems',
      'Emergency backup systems',
      'Integration with existing hospital utilities'
    ],
    generalContractor: 'Kitchell Contractors Inc.',
    architect: 'Hobbs and Black Architect',
    additionalInfo: `This critical trauma center expansion for Phoenix Children's Hospital demonstrates Bel-Aire Mechanical's expertise in 
    specialized pediatric healthcare facilities. The project required careful coordination to maintain hospital operations while installing sophisticated 
    mechanical systems designed for the unique demands of pediatric trauma care. Advanced BIM coordination ensured seamless integration with existing 
    hospital infrastructure, while specialized HVAC and plumbing systems provide the precise environmental controls necessary for optimal patient care 
    and outcomes. The facility's mechanical systems support Arizona's only Level I Pediatric Trauma Center, providing critical care capabilities 
    for the region's most vulnerable patients.`
  },
  {
    id: 'asu-bio-c',
    title: 'ASU Bio C',
    location: 'Tempe, AZ',
    year: 2018,
    category: 'Higher Education',
    client: 'Arizona State University',
    featuredImage: '/images/projects/asu-bio-c-featured.jpg',
    images: [
      '/images/projects/asu-bio-c-01.jpg',
      '/images/projects/asu-bio-c-02.jpg',
      '/images/projects/asu-bio-c-03.jpg',
      '/images/projects/asu-bio-c-04.jpg',
    ],
    shortDescription: 'State-of-the-art bioscience research facility with advanced HVAC and laboratory mechanical systems',
    description: `ASU Bio C represents a cutting-edge bioscience research facility on Arizona State University's Tempe campus. This sophisticated 
    facility required advanced mechanical systems designed to support specialized research laboratories, precise environmental controls for biological 
    research, and complex HVAC systems to maintain optimal conditions for scientific discovery. Bel-Aire Mechanical provided comprehensive mechanical 
    and plumbing systems working with McCarthy Building Companies and AEI engineering to deliver a facility that supports ASU's leadership in 
    bioscience research and innovation.`,
    services: ['HVAC Systems', 'Plumbing', 'Laboratory Systems', 'BIM-VDC'],
    scope: 'Advanced bioscience research facility with specialized laboratory HVAC, plumbing, and environmental control systems',
    challenges: [
      'Precision environmental controls for biological research',
      'Complex laboratory ventilation requirements',
      'Integration with campus utilities and infrastructure',
      'Specialized exhaust systems for research labs',
      'Temperature and humidity control for sensitive experiments',
      'Coordination with research equipment requirements',
      'Laboratory safety ventilation standards',
      'Energy-efficient design for research facility'
    ],
    features: [
      'Specialized laboratory HVAC systems',
      'Precision environmental controls for bioscience research',
      'Advanced laboratory exhaust systems',
      'Fume hood ventilation infrastructure',
      'Temperature and humidity control systems',
      'High-efficiency air filtration',
      'Laboratory plumbing infrastructure',
      'Research-grade water systems',
      'Emergency backup systems',
      'Energy-efficient mechanical design',
      'Integration with campus infrastructure',
      'Advanced building automation systems'
    ],
    generalContractor: 'McCarthy Building Companies, Inc',
    architect: 'Zimmer Gunsul Frasca Architects, LLP',
    engineer: 'AEI',
    additionalInfo: `ASU Bio C demonstrates Bel-Aire Mechanical's continued partnership with Arizona State University and expertise in specialized 
    research facilities. This bioscience research building required sophisticated mechanical systems designed to support cutting-edge biological 
    research with precise environmental controls and advanced laboratory ventilation. Working with McCarthy Building Companies as general contractor, 
    Zimmer Gunsul Frasca Architects, and AEI engineering, Bel-Aire delivered comprehensive HVAC, plumbing, and laboratory systems that enable 
    groundbreaking research in biosciences. The facility expands ASU's research capabilities and reinforces the university's position as a leader 
    in bioscience innovation and discovery.`
  },
  {
    id: 'desert-diamond-west-valley-2020',
    title: 'Desert Diamond West Valley Casino - Phase 2',
    location: 'Glendale, AZ',
    year: 2020,
    category: 'Casino-Resort',
    client: 'Tohono O&apos;odham Gaming Enterprise',
    featuredImage: '/images/projects/desert-diamond-2020-featured.jpg',
    images: [
      '/images/projects/desert-diamond-2020-01.jpg',
      '/images/projects/desert-diamond-2020-02.jpg',
      '/images/projects/desert-diamond-2020-03.jpg',
      '/images/projects/desert-diamond-2020-04.jpg',
      '/images/projects/desert-diamond-2020-05.jpg',
    ],
    shortDescription: 'Major casino expansion with advanced HVAC and plumbing systems for enhanced gaming and hospitality facilities',
    description: `The second phase expansion of the Desert Diamond West Valley Casino represents a major enhancement to one of the valley&apos;s premier 
    gaming and entertainment destinations. Building on the success of the 2016 initial opening, this expansion project required sophisticated mechanical 
    systems designed to support expanded gaming facilities, additional amenities, and enhanced guest experiences. Bel-Aire Mechanical provided comprehensive 
    HVAC and plumbing systems with advanced BIM-VDC coordination to ensure seamless integration with the existing facility while maintaining continuous 
    24/7 casino operations throughout construction.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Assist', 'BIM-VDC'],
    scope: 'Major casino expansion with advanced HVAC, plumbing, and mechanical systems for gaming, hospitality, and entertainment facilities',
    challenges: [
      'Maintaining 24/7 casino operations during construction',
      'Integration with existing 2016 facility systems',
      'Expansion of central plant capacity',
      'Complex BIM coordination for phased construction',
      'Immense ventilation requirements for gaming areas',
      'Coordination with multiple entertainment and dining venues',
      'Fast-track construction schedule',
      'Tie-ins to existing mechanical infrastructure'
    ],
    features: [
      'Expanded casino gaming floor HVAC',
      'Enhanced central plant capacity',
      'Advanced air distribution systems',
      'Variable frequency drive systems',
      'Efficient cooling and ventilation for gaming areas',
      'Restaurant and food service plumbing',
      'Entertainment venue mechanical systems',
      'Guest amenity facilities',
      'Advanced BIM-VDC coordination',
      '24/7 operational capability',
      'Energy-efficient mechanical design',
      'Seamless integration with Phase 1 systems',
      'Redundant systems for reliability'
    ],
    generalContractor: 'Hunt / Penta Construction',
    architect: 'HBG Design',
    engineer: 'NV5',
    additionalInfo: `This Phase 2 expansion of the Desert Diamond West Valley Casino demonstrates Bel-Aire Mechanical&apos;s continued partnership with 
    Tohono O&apos;odham Gaming Enterprise, following the successful completion of the initial facility in 2016. The project required careful coordination 
    to maintain continuous casino operations while integrating new mechanical systems with the existing infrastructure. Advanced BIM-VDC coordination 
    ensured efficient installation and minimized disruption to the 24/7 gaming operations. The expansion enhances the resort&apos;s position as one of 
    the valley&apos;s premier entertainment destinations, with sophisticated HVAC and plumbing systems designed to support expanded gaming facilities, 
    additional dining and entertainment venues, and enhanced guest amenities.`
  },
  {
    id: 'banner-university-medical-center-tucson',
    title: 'Banner University Medical Center - Tucson',
    location: 'Tucson, AZ',
    year: 2019,
    category: 'Healthcare',
    client: 'Banner Health',
    featuredImage: '/images/projects/banner-tucson-featured.jpg',
    images: [
      '/images/projects/banner-tucson-01.jpg',
      '/images/projects/banner-tucson-02.jpg',
      '/images/projects/banner-tucson-03.jpg',
      '/images/projects/banner-tucson-04.jpg',
      '/images/projects/banner-tucson-05.jpg',
    ],
    shortDescription: 'Major medical center project with advanced HVAC, plumbing, and medical gas systems for comprehensive healthcare services',
    description: `Banner University Medical Center - Tucson represents a significant healthcare facility project in Southern Arizona. This major medical 
    center required sophisticated mechanical systems designed to support comprehensive healthcare services including patient care, diagnostic imaging, 
    surgical suites, and specialized treatment areas. Bel-Aire Mechanical provided comprehensive HVAC, plumbing, and medical gas systems with advanced 
    coordination to ensure optimal patient care environments and operational efficiency. The project demonstrates Bel-Aire&apos;s continued partnership 
    with Banner Health, one of Arizona&apos;s largest healthcare systems.`,
    services: ['HVAC Systems', 'Plumbing', 'Medical Gas', 'BIM-VDC'],
    scope: 'Comprehensive medical center mechanical systems including HVAC, plumbing, and medical gas for patient care and treatment facilities',
    challenges: [
      'Working in active medical center environment',
      'Maintaining infection control standards',
      'Integration with existing hospital infrastructure',
      'Precision environmental controls for medical spaces',
      'Complex medical gas distribution systems',
      '24/7 operational requirements',
      'Coordination with multiple healthcare specialties',
      'Meeting stringent healthcare regulations and codes'
    ],
    features: [
      'Advanced HVAC systems for patient care areas',
      'Medical gas distribution infrastructure',
      'Specialized ventilation for surgical suites',
      'Precision climate control for diagnostic imaging',
      'Infection control air handling systems',
      'High-efficiency air filtration',
      'Emergency backup mechanical systems',
      'Plumbing infrastructure for medical facilities',
      'Operating room environmental controls',
      'Patient room HVAC systems',
      'Laboratory ventilation systems',
      'Redundant systems for reliability',
      '24/7 operational capability'
    ],
    generalContractor: 'Hensel Phelps',
    architect: 'Smithgroup JJR',
    engineer: 'Smithgroup JJR',
    additionalInfo: `This major medical center project in Tucson demonstrates Bel-Aire Mechanical&apos;s continued partnership with Banner Health and 
    expertise in large-scale healthcare facilities. The project required sophisticated mechanical systems designed to support comprehensive healthcare 
    services while maintaining the highest standards of patient care and safety. Working with Hensel Phelps as general contractor and Smithgroup JJR 
    as both architect and engineer, Bel-Aire delivered advanced HVAC, plumbing, and medical gas systems that ensure optimal environmental conditions 
    for patient care, surgical procedures, diagnostic imaging, and specialized treatment areas. The facility expands Banner Health&apos;s presence in 
    Southern Arizona, providing critical healthcare services to the Tucson community and region.`
  },
  {
    id: 'fox-technology-center',
    title: 'FOX Technology Center',
    location: 'Tempe, AZ',
    year: 2020,
    category: 'Data Center',
    client: 'Fox Corp',
    featuredImage: '/images/projects/fox-tech-center-featured.jpg',
    images: [
      '/images/projects/fox-tech-center-01.jpg',
      '/images/projects/fox-tech-center-02.jpg',
      '/images/projects/fox-tech-center-03.jpg',
      '/images/projects/fox-tech-center-04.jpg',
      '/images/projects/fox-tech-center-05.jpg',
    ],
    shortDescription: 'Mission-critical technology center with advanced HVAC and precision cooling systems for media broadcasting operations',
    description: `The FOX Technology Center in Tempe represents a state-of-the-art mission-critical facility designed to support Fox Corporation&apos;s 
    broadcasting and media technology operations. This sophisticated facility required advanced HVAC systems, precision cooling, and comprehensive 
    plumbing infrastructure to support high-density technology equipment and ensure uninterrupted broadcasting operations. Bel-Aire Mechanical provided 
    comprehensive mechanical systems with Design Assist services and advanced BIM coordination, working closely with EYP Mission Critical engineering 
    specialists to deliver a facility that meets the rigorous demands of modern media broadcasting and technology operations.`,
    services: ['HVAC Systems', 'Plumbing', 'Design Assist', 'BIM-VDC', 'Precision Cooling'],
    scope: 'Mission-critical technology center with advanced HVAC, precision cooling, and plumbing systems for media broadcasting operations',
    challenges: [
      'Mission-critical uptime requirements for broadcasting',
      'Precision cooling for high-density technology equipment',
      'Advanced BIM coordination with mission-critical engineer',
      'Integration with broadcasting infrastructure',
      'Redundant mechanical systems for reliability',
      'Tight temperature and humidity control requirements',
      'Coordination with specialized technology equipment',
      'Fast-track construction schedule'
    ],
    features: [
      'Mission-critical HVAC systems',
      'Precision cooling for technology equipment',
      'Redundant mechanical infrastructure',
      'Advanced air handling systems',
      'High-efficiency cooling design',
      'Emergency backup mechanical systems',
      'Sophisticated monitoring and control systems',
      'Energy-efficient design',
      'Variable frequency drive systems',
      'Dedicated cooling for server and broadcast equipment',
      'Comprehensive plumbing infrastructure',
      'Advanced BIM coordination',
      '24/7 operational capability'
    ],
    generalContractor: 'Holder',
    architect: 'Archcentruc',
    engineer: 'EYP Mission Critical',
    additionalInfo: `The FOX Technology Center demonstrates Bel-Aire Mechanical&apos;s expertise in mission-critical facilities for the media and 
    broadcasting industry. Working with EYP Mission Critical engineering specialists, Bel-Aire provided Design Assist services and advanced BIM 
    coordination to deliver sophisticated mechanical systems that support Fox Corporation&apos;s technology and broadcasting operations. The facility 
    features redundant HVAC systems, precision cooling for high-density equipment, and comprehensive monitoring and control systems to ensure continuous 
    operation. The project showcases Bel-Aire&apos;s ability to deliver complex mission-critical facilities that meet the demanding requirements of 
    modern media operations, including uninterrupted broadcasting capabilities and support for cutting-edge technology infrastructure.`
  },
  {
    id: 'banner-desert-medical-center-womens-tower',
    title: 'Banner Desert Medical Center - Women\'s Tower',
    location: 'Mesa, AZ',
    year: 2024,
    category: 'Healthcare',
    client: 'Banner Health',
    featuredImage: '/images/projects/banner-desert-womens-tower-featured.jpg',
    images: [
      '/images/projects/banner-desert-womens-tower-01.jpg',
      '/images/projects/banner-desert-womens-tower-02.jpg',
      '/images/projects/banner-desert-womens-tower-03.jpg',
      '/images/projects/banner-desert-womens-tower-04.jpg',
      '/images/projects/banner-desert-womens-tower-05.jpg',
    ],
    shortDescription: 'Specialized women\'s healthcare tower with advanced HVAC, plumbing, and medical systems for comprehensive maternal and women\'s care',
    description: `The Banner Desert Medical Center Women's Tower represents a significant expansion of specialized healthcare services for women in 
    the East Valley. This dedicated tower features state-of-the-art facilities for maternal care, obstetrics, gynecology, and women's health services. 
    Bel-Aire Mechanical is providing comprehensive HVAC and plumbing systems with advanced BIM coordination to support this specialized healthcare facility. 
    The project demonstrates Bel-Aire's continued partnership with Banner Health and expertise in specialized medical facilities designed to meet the 
    unique requirements of women's healthcare services.`,
    services: ['HVAC Systems', 'Plumbing', 'BIM-VDC', 'Medical Gas'],
    scope: 'Specialized women\'s healthcare tower with comprehensive mechanical systems for maternal care, obstetrics, and women\'s health services',
    challenges: [
      'Working in active hospital campus environment',
      'Specialized environmental controls for maternal care',
      'Integration with existing Banner Desert Medical Center',
      'Infection control standards for obstetrics and labor & delivery',
      'Precision HVAC for neonatal and maternal care areas',
      'Complex medical gas systems for labor & delivery suites',
      'Advanced BIM coordination for multi-story tower',
      'Phased construction while maintaining hospital operations'
    ],
    features: [
      'Specialized HVAC for maternal care areas',
      'Labor & delivery suite environmental controls',
      'NICU-ready mechanical systems',
      'Medical gas distribution for obstetrics',
      'Infection control ventilation systems',
      'Patient room climate control',
      'Operating room HVAC systems',
      'Recovery area environmental controls',
      'Plumbing infrastructure for medical facilities',
      'Emergency backup mechanical systems',
      'Advanced BIM coordination',
      'Energy-efficient design',
      'High-efficiency air filtration',
      '24/7 operational capability'
    ],
    generalContractor: 'DPR Construction',
    architect: 'CUNINGHAM GROUP',
    engineer: 'AEI',
    additionalInfo: `The Banner Desert Medical Center Women's Tower project demonstrates Bel-Aire Mechanical's ongoing partnership with Banner 
    Health and expertise in specialized healthcare facilities. This dedicated women's healthcare tower requires sophisticated mechanical systems 
    designed to support maternal care, labor & delivery, obstetrics, and comprehensive women's health services. Working with DPR Construction, 
    CUNINGHAM GROUP, and AEI, Bel-Aire is delivering advanced HVAC and plumbing systems with comprehensive BIM coordination to ensure optimal patient 
    care environments. The facility expands Banner Health's specialized women's healthcare services in Mesa and the East Valley, providing 
    state-of-the-art facilities for maternal and women's health. The project showcases Bel-Aire's ability to deliver complex medical facilities 
    with specialized requirements for patient safety, comfort, and optimal clinical outcomes.`
  },
  
];

export const categories = [
  'All',
  'Casino-Resort',
  'Corporate',
  'Data Center',
  'Healthcare',
  'Higher Education',
  'Laboratories'
];

